// extracted by mini-css-extract-plugin
export default {"warning":"YM6weyVNSoGyptDt5c05"};